/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCallback, useState } from "react";
import { useInvoiceAddPackageInstance } from "../../lib/react-query/useInvoiceAddPackageInstance";
import { useInvoiceRemovePackageInstance } from "../../lib/react-query/useInvoiceRemovePackageInstance";
import { useToast } from "../../components/ui/Toast";
import { TOAST_ERROR_MESSAGE } from "../../constants/constants";

export const usePackageSelection = (invoice) => {
  const { toast } = useToast();
  const [pendingPackageId, setPendingPackageId] = useState(null);

  const { mutate: addPackageInstance } = useInvoiceAddPackageInstance(invoice.id);
  const { mutate: removePackageInstance } = useInvoiceRemovePackageInstance(invoice.id);

  const handlePackageSelect = useCallback(
    (id, onSuccess) => {
      const isSelected = invoice.package_instances.find((instance) => instance.id === id);
      const mutation = isSelected ? removePackageInstance : addPackageInstance;

      setPendingPackageId(id);
      mutation(
        { package_instance_id: id },
        {
          onSuccess: (data) => {
            onSuccess?.(data);
            setPendingPackageId(null);
          },
          onError: (error) => {
            toast({
              title: "Error!",
              description: TOAST_ERROR_MESSAGE.DEFAULT,
              variant: "error",
            });
            setPendingPackageId(null);
          },
        }
      );
    },
    [addPackageInstance, removePackageInstance, invoice.package_instances, invoice.id, toast]
  );

  return {
    handlePackageSelect,
    pendingPackageId,
  };
};
